import type { ApiClientV2 } from 'utils/api-client/api-client.utils'
import { TrackingLogAttributes } from 'types/__generated__/api'
import { FromSwagger } from 'types/helpers'

export type TrackingLog = FromSwagger<TrackingLogAttributes>

const BASE_URL = (username: string) => `/shop/${username}/tracking_logs`

export interface ReqBody {
  form: string
  username: string
  trackingCodeId: number
  trackingEventId?: Record<string, never> | number
  sellerId?: number
  trackingCodeForm?: string
  info?: {
    name?: string
    form?: string
    code: string
    customerToken: string | boolean
    orderId?: number
    productId?: number | string
    productPrice?: number | string
    currency?: string
    url?: string
  }
  orderId?: number
  // MAC-1766 — shared dedup key sent alongside each Pixel fire; backend
  // stores it on the TrackingLog so the CAPI worker can dedupe with Meta.
  eventId?: string
  // Meta's _fbp/_fbc cookies, snapshotted into request_signals backend-side
  // so the CAPI worker can build mid-funnel user_data.
  fbp?: string
  fbc?: string
}

export const createTrackingLogApi = ({ POST }: ApiClientV2) => ({
  trackingLog: ({ username, ...restData }: ReqBody) => POST(BASE_URL(username), { type: 'tracking_logs', ...restData }),
})

export type TrackingLogApi = ReturnType<typeof createTrackingLogApi>
